class SubscriptionPaymentDetailsWithCard implements ng.IComponentController {
    type: anm.CardType;
    expires: string;
    last4: string;
    status: string;
    errorMessage: string;
    onChange: () => void;

    constructor() {
    }
}

angular.module('animatronApp.SubscriptionPaymentDetailsWithCard', [])
    .component('subscriptionPaymentDetailsWithCard', {
        bindings: {
            status: '<',
            type: '<',
            last4: '<',
            expires: '<',
            errorMessage: '<?',
            onChange: '&?'
        },
        controller: SubscriptionPaymentDetailsWithCard,
        templateUrl: require('settings/subscription/payment-details/subscription-payment-details-with-card.html')
    });



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/payment-details/SubscriptionPaymentDetailsWithCard.ts